export const SELECT_STATUS_FILTER = "SELECT_STATUS_FILTER";
export const INVALIDATE_STATUS_FILTER = "INVALIDATE_STATUS_FILTER";

export const REQUEST_WEVOS = "REQUEST_WEVOS";
export const RECIEVE_WEVOS = "RECIEVE_WEVOS";
export const GET_WEVOS_FAILURE = "GET_WEVOS_FAILURE";

export const ADD_WEVO = "ADD_WEVO";
export const ADD_WEVO_SUCCESS = "ADD_WEVO_SUCCESS";
export const ADD_WEVO_FAILURE = "ADD_WEVO_FAILURE";

export const DELETE_WEVO = "DELETE_WEVO";
export const DELETE_WEVO_SUCCESS = "DELETE_WEVO_SUCCESS";
export const DELETE_WEVO_FAILURE = "DELETE_WEVO_FAILURE";

export const CLONE_WEVO = "CLONE_WEVO";
export const CLONE_WEVO_SUCCESS = "CLONE_WEVO_SUCCESS";
export const CLONE_WEVO_FAILURE = "CLONE_WEVO_FAILURE";

export const LAUNCH_WEVO_FAILURE = "LAUNCH_WEVO_FAILURE";
export const LAUNCH_WEVO_SUCCESS = "LAUNCH_WEVO_SUCCESS";
export const LAUNCH_WEVO_REQUEST = "LAUNCH_WEVO_REQUEST";

export const REQUEST_WEVO_RESULTS = "REQUEST_WEVO_RESULTS";
export const WEVO_RESULTS_SUCCESS = "WEVO_RESULTS_SUCCESS";

export const WEVO_RESULTS_ERROR = "WEVO_RESULTS_ERROR";



// WEBPACK FOOTER //
// ./src/modules/wevos/types.js